// Veo imports
import { veo as veoEn } from './veo/generator_en.js';
import { veo as veoTc } from './veo/generator_tc.js';
import { veo as veoSc } from './veo/generator_sc.js';
import { veoHero as veoHeroEn } from './veo/hero_en.js';
import { veoHero as veoHeroTc } from './veo/hero_tc.js';
import { veoHero as veoHeroSc } from './veo/hero_sc.js';
import { veoExamples as veoExamplesEn } from './veo/examples_en.js';
import { veoExamples as veoExamplesTc } from './veo/examples_tc.js';
import { veoExamples as veoExamplesSc } from './veo/examples_sc.js';
import { veoShowcase as veoShowcaseEn } from './veo/showcase_en.js';
import { veoShowcase as veoShowcaseTc } from './veo/showcase_tc.js';
import { veoShowcase as veoShowcaseSc } from './veo/showcase_sc.js';
import { veoFeatures as veoFeaturesEn } from './veo/features_en.js';
import { veoFeatures as veoFeaturesTc } from './veo/features_tc.js';
import { veoFeatures as veoFeaturesSc } from './veo/features_sc.js';
import { veoFAQ as veoFAQEn } from './veo/faq_en.js';
import { veoFAQ as veoFAQTc } from './veo/faq_tc.js';
import { veoFAQ as veoFAQSc } from './veo/faq_sc.js';
import { veoHowto as veoHowtoEn } from './veo/howto_en.js';
import { veoHowto as veoHowtoTc } from './veo/howto_tc.js';
import { veoHowto as veoHowtoSc } from './veo/howto_sc.js';

// Wan imports
import { wan as wanEn } from './wan/generator_en.js';
import { wan as wanTc } from './wan/generator_tc.js';
import { wan as wanSc } from './wan/generator_sc.js';
import { wanHero as wanHeroEn } from './wan/hero_en.js';
import { wanHero as wanHeroTc } from './wan/hero_tc.js';
import { wanHero as wanHeroSc } from './wan/hero_sc.js';
import { wanExamples as wanExamplesEn } from './wan/examples_en.js';
import { wanExamples as wanExamplesTc } from './wan/examples_tc.js';
import { wanExamples as wanExamplesSc } from './wan/examples_sc.js';
import { wanFeatures as wanFeaturesEn } from './wan/features_en.js';
import { wanFeatures as wanFeaturesTc } from './wan/features_tc.js';
import { wanFeatures as wanFeaturesSc } from './wan/features_sc.js';
import { wanFAQ as wanFAQEn } from './wan/faq_en.js';
import { wanFAQ as wanFAQTc } from './wan/faq_tc.js';
import { wanFAQ as wanFAQSc } from './wan/faq_sc.js';
import { wanSteps as wanStepsEn } from './wan/steps_en.js';
import { wanSteps as wanStepsTc } from './wan/steps_tc.js';
import { wanSteps as wanStepsSc } from './wan/steps_sc.js';

// Sora imports
import { sora as soraEn } from './sora/generator_en.js';
import { sora as soraTc } from './sora/generator_tc.js';
import { sora as soraSc } from './sora/generator_sc.js';
import { soraHero as soraHeroEn } from './sora/hero_en.js';
import { soraHero as soraHeroTc } from './sora/hero_tc.js';
import { soraHero as soraHeroSc } from './sora/hero_sc.js';
import { soraExamples as soraExamplesEn } from './sora/examples_en.js';
import { soraExamples as soraExamplesTc } from './sora/examples_tc.js';
import { soraExamples as soraExamplesSc } from './sora/examples_sc.js';
import { soraFeatures as soraFeaturesEn } from './sora/features_en.js';
import { soraFeatures as soraFeaturesTc } from './sora/features_tc.js';
import { soraFeatures as soraFeaturesSc } from './sora/features_sc.js';
import { soraFAQ as soraFAQEn } from './sora/faq_en.js';
import { soraFAQ as soraFAQTc } from './sora/faq_tc.js';
import { soraFAQ as soraFAQSc } from './sora/faq_sc.js';
import { soraSteps as soraStepsEn } from './sora/steps_en.js';
import { soraSteps as soraStepsTc } from './sora/steps_tc.js';
import { soraSteps as soraStepsSc } from './sora/steps_sc.js';
import { mv as mvEn } from './mv/mv_en.js';
import { mv as mvTc } from './mv/mv_tc.js';
import { mv as mvSc } from './mv/mv_sc.js';

// Intermediate objects
const veo = { en: veoEn, 'zh-TW': veoTc, zh: veoSc };
const veoHero = { en: veoHeroEn, 'zh-TW': veoHeroTc, zh: veoHeroSc };
const veoExamples = { en: veoExamplesEn, 'zh-TW': veoExamplesTc, zh: veoExamplesSc };
const veoShowcase = { en: veoShowcaseEn, 'zh-TW': veoShowcaseTc, zh: veoShowcaseSc };
const veoFeatures = { en: veoFeaturesEn, 'zh-TW': veoFeaturesTc, zh: veoFeaturesSc };
const veoFAQ = { en: veoFAQEn, 'zh-TW': veoFAQTc, zh: veoFAQSc };
const veoHowto = { en: veoHowtoEn, 'zh-TW': veoHowtoTc, zh: veoHowtoSc };

const wan = { en: wanEn, 'zh-TW': wanTc, zh: wanSc };
const wanHero = { en: wanHeroEn, 'zh-TW': wanHeroTc, zh: wanHeroSc };
const wanExamples = { en: wanExamplesEn, 'zh-TW': wanExamplesTc, zh: wanExamplesSc };
const wanFeatures = { en: wanFeaturesEn, 'zh-TW': wanFeaturesTc, zh: wanFeaturesSc };
const wanFAQ = { en: wanFAQEn, 'zh-TW': wanFAQTc, zh: wanFAQSc };
const wanSteps = { en: wanStepsEn, 'zh-TW': wanStepsTc, zh: wanStepsSc };

const sora = { en: soraEn, 'zh-TW': soraTc, zh: soraSc };
const soraHero = { en: soraHeroEn, 'zh-TW': soraHeroTc, zh: soraHeroSc };
const soraExamples = { en: soraExamplesEn, 'zh-TW': soraExamplesTc, zh: soraExamplesSc };
const soraFeatures = { en: soraFeaturesEn, 'zh-TW': soraFeaturesTc, zh: soraFeaturesSc };
const soraFAQ = { en: soraFAQEn, 'zh-TW': soraFAQTc, zh: soraFAQSc };
const soraSteps = { en: soraStepsEn, 'zh-TW': soraStepsTc, zh: soraStepsSc };
const mv = { en: mvEn, 'zh-TW': mvTc, zh: mvSc };

export const videoGeneration = {
  en: {
    veo: { ...veo.en, hero: veoHero.en, showcase: veoShowcase.en, features: veoFeatures.en, faq: veoFAQ.en, howto: veoHowto.en, examples: veoExamples.en },
    wan: { ...wan.en, hero: wanHero.en, features: wanFeatures.en, faq: wanFAQ.en, steps: wanSteps.en, examples: wanExamples.en },
    sora: { ...sora.en, hero: soraHero.en, features: soraFeatures.en, faq: soraFAQ.en, steps: soraSteps.en, examples: soraExamples.en },
    mv: mv.en,
  },
  'zh-TW': {
    veo: { ...veo['zh-TW'], hero: veoHero['zh-TW'], showcase: veoShowcase['zh-TW'], features: veoFeatures['zh-TW'], faq: veoFAQ['zh-TW'], howto: veoHowto['zh-TW'], examples: veoExamples['zh-TW'] },
    wan: { ...wan['zh-TW'], hero: wanHero['zh-TW'], features: wanFeatures['zh-TW'], faq: wanFAQ['zh-TW'], steps: wanSteps['zh-TW'], examples: wanExamples['zh-TW'] },
    sora: { ...sora['zh-TW'], hero: soraHero['zh-TW'], features: soraFeatures['zh-TW'], faq: soraFAQ['zh-TW'], steps: soraSteps['zh-TW'], examples: soraExamples['zh-TW'] },
    mv: mv['zh-TW'],
  },
  zh: {
    veo: { ...veo.zh, hero: veoHero.zh, showcase: veoShowcase.zh, features: veoFeatures.zh, faq: veoFAQ.zh, howto: veoHowto.zh, examples: veoExamples.zh },
    wan: { ...wan.zh, hero: wanHero.zh, features: wanFeatures.zh, faq: wanFAQ.zh, steps: wanSteps.zh, examples: wanExamples.zh },
    sora: { ...sora.zh, hero: soraHero.zh, features: soraFeatures.zh, faq: soraFAQ.zh, steps: soraSteps.zh, examples: soraExamples.zh },
    mv: mv.zh,
  }
};
